webpackJsonp([3],{

/***/ 636:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var ServiceFactory = __webpack_require__(484),
	    ChatProvider = new (__webpack_require__(637))();

	module.exports = ServiceFactory.create({
		displayName: 'Chat',
		methods: {
			getMessageUnreadCount: function getMessageUnreadCount(_ref) {
				var _this = this;

				var uuid = _ref.uuid,
				    isHilda = _ref.isHilda;

				return ChatProvider.getMessageUnreadCount({ uuid: uuid, isHilda: false }).then(function (result) {
					_this.dispatch({
						type: 'CHAT_GET_MESSAGE_UNREAD_COUNT_SUCCESS',
						payload: result
					});
					return result;
				});
			},
			getHildaMessageUnreadCount: function getHildaMessageUnreadCount(_ref2) {
				var _this2 = this;

				var uuid = _ref2.uuid;

				return ChatProvider.getMessageUnreadCount({ uuid: uuid, isHilda: true }).then(function (result) {
					_this2.dispatch({
						type: 'CHAT_GET_HILDA_MESSAGE_UNREAD_COUNT_SUCCESS',
						payload: result
					});
					return result;
				});
			}
		}
		});

/***/ }),

/***/ 637:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var ApiService = __webpack_require__(486),
	    Axios = __webpack_require__(487),
	    config = __webpack_require__(340);

	var ChatService = function (_ApiService) {
		_inherits(ChatService, _ApiService);

		function ChatService(init) {
			_classCallCheck(this, ChatService);

			return _possibleConstructorReturn(this, (ChatService.__proto__ || Object.getPrototypeOf(ChatService)).call(this, init));
		}

		_createClass(ChatService, [{
			key: 'getMessageUnreadCount',
			value: function getMessageUnreadCount(_ref) {
				var uuid = _ref.uuid,
				    isHilda = _ref.isHilda;

				var data = void 0;
				if (isHilda) {
					data = {
						'query': 'query UnreadCount($subscribeKey: String!, $uuid: String!)  { unreadCount(subscribeKey: $subscribeKey, uuid: $uuid) }',
						'variables': {
							subscribeKey: config.chatHildaSubscribeKey,
							uuid: uuid
						},
						operationName: 'UnreadCount'
					};
				} else {
					data = {
						'query': 'query UnreadCount($subscribeKey: String!, $suSubscribeKey: String!, $uuid: String!)  { unreadCount(subscribeKey: $subscribeKey, uuid: $uuid) specialUserUnreadCount: unreadCount(subscribeKey: $suSubscribeKey, uuid: $uuid)}',
						'variables': {
							subscribeKey: config.chatSubscribeKey,
							suSubscribeKey: config.chatSpecialUserSubscribeKey,
							uuid: uuid
						},
						operationName: 'UnreadCount'
					};
				}
				return Axios({
					method: 'POST',
					url: config.chatBackendBaseUrl + '/securegraphql',
					data: JSON.stringify(data),
					headers: {
						'Content-Type': 'application/json'
					},
					withCredentials: true
				});
			}
		}]);

		return ChatService;
	}(ApiService);

		module.exports = ChatService;

/***/ }),

/***/ 638:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var ServiceFactory = __webpack_require__(484),
	    NotificationProvider = new (__webpack_require__(639))();

	module.exports = ServiceFactory.create({
		displayName: 'Notification',
		methods: {
			getNotificationUnreadCount: function getNotificationUnreadCount(accountId, sessionId) {
				var _this = this;

				return NotificationProvider.getNotificationUnreadCount(accountId, sessionId).then(function (result) {
					_this.dispatch({
						type: 'NOTIFICATION_UNREAD_COUNT_SUCCESS',
						payload: result
					});
					return result;
				});
			},
			getAppBadgeNumbers: function getAppBadgeNumbers(sessionId) {
				var _this2 = this;

				return NotificationProvider.getAppBadgeNumbers(sessionId).then(function (result) {
					_this2.dispatch({
						type: 'NOTIFICATION_UNREAD_COUNT_VENDOR_SUCCESS',
						payload: result
					});
					return result;
				});
			}

		}
		});

/***/ }),

/***/ 639:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var ApiService = __webpack_require__(486),
	    Axios = __webpack_require__(487),
	    config = __webpack_require__(340);

	var NotificationService = function (_ApiService) {
		_inherits(NotificationService, _ApiService);

		function NotificationService(init) {
			_classCallCheck(this, NotificationService);

			return _possibleConstructorReturn(this, (NotificationService.__proto__ || Object.getPrototypeOf(NotificationService)).call(this, init));
		}

		_createClass(NotificationService, [{
			key: 'getNotificationUnreadCount',
			value: function getNotificationUnreadCount(accountId) {
				var data = {
					'query': "query get_unread_count($applicationId: Int!, $accountId: Int!){unreadCount(applicationId: $applicationId, targetId: $accountId)}",
					'variables': {
						applicationId: config.activityStreamAppId,
						accountId: accountId
					},
					operationName: 'get_unread_count'
				};
				return Axios({
					method: 'POST',
					url: config.activityStreamBaseUrl + '/graphql',
					data: JSON.stringify(data),
					headers: {
						'Content-Type': 'application/json',
						'x-as-appid': config.activityStreamAppId
					},
					withCredentials: true
				});
			}
		}, {
			key: 'getAppBadgeNumbers',
			value: function getAppBadgeNumbers(sessionId) {
				return this.get({
					url: 'v2/mobile_apps/self/badges',
					headers: {
						'Content-Type': 'application/json'
					},
					withCredentials: true
				});
			}
		}]);

		return NotificationService;
	}(ApiService);

		module.exports = NotificationService;

/***/ }),

/***/ 645:
/***/ (function(module, exports) {

	'use strict';

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	module.exports = {
	    push: function push(properties, user, spa) {
	        window.dataLayer = window.dataLayer || [];
	        var layerData = {
	            is_revamped: 'revamped',
	            v2_pageProperties: {
	                category: properties.category,
	                subCategory: properties.subCategory
	            }
	        };

	        if (properties.property) {
	            layerData.properties = properties.property;
	        }

	        if (user) {
	            layerData.v2_userId = user.accountId;
	            layerData.v2_loginType = user.isVendor ? 'vendor' : 'user';
	        }

	        if (!this.checkDataLayer('originalLocation')) {
	            layerData.originalLocation = document.location.protocol + '//' + document.location.hostname + document.location.pathname + document.location.search;
	        }

	        if (spa || this.checkDataLayer('event', 'gtm.historyChange')) {
	            layerData.event = 'v2_spa_pageview';

	            if (!this.checkDataLayer('v2_spa_referral') && typeof window.google_tag_manager != "undefined" && window.google_tag_manager['GTM-W9GZHRT']) {
	                layerData.v2_spa_referral = window.google_tag_manager['GTM-W9GZHRT'].dataLayer.get('originalLocation');
	            } else if (typeof window.google_tag_manager != "undefined" && window.google_tag_manager['GTM-W9GZHRT']) {
	                layerData.v2_spa_referral = window.google_tag_manager['GTM-W9GZHRT'].dataLayer.get('originalLocationSPA');
	            }

	            layerData.originalLocationSPA = document.location.protocol + '//' + document.location.hostname + document.location.pathname + document.location.search;
	        }
	        window.dataLayer.push(layerData);
	    },

	    checkDataLayer: function checkDataLayer($key, $val) {
	        var res = false;
	        var dlname = void 0;
	        if (typeof window.google_tag_manager != "undefined") {
	            for (var i in window.google_tag_manager) {
	                if (_typeof(window.google_tag_manager[i]) == "object" && window.google_tag_manager[i].gtmDom) dlname = i;
	            }
	            for (var _i in window[dlname]) {
	                if (!$val & $val != '') {
	                    if (window[dlname][_i][$key]) {
	                        return true;
	                    }
	                } else {
	                    if (window[dlname][_i][$key] && window[dlname][_i][$key] == $val) {
	                        return true;
	                    }
	                }
	            }
	        }
	        return res;
	    },

	    leads: function leads(properties) {
	        window.dataLayer = window.dataLayer || [];
	        window.dataLayer.push({
	            event: 'v2_leads',
	            v2_leadsProperties: {
	                type: properties.type,
	                vendorId: properties.vendorId,
	                vendorSlug: properties.vendorSlug
	            }
	        });
	    },

	    auth: function auth(event, type, payload) {
	        window.dataLayer = window.dataLayer || [];
	        window.dataLayer.push({
	            event: event,
	            v2_authentication_method: type,
	            v2_userId: payload.user && payload.user.account.data.id || payload.vendor.account.data.id,
	            v2_loginType: payload.user && payload.user.type || payload.vendor.type
	        });
	    },

	    ppc: function ppc(vendor) {
	        window.dataLayer = window.dataLayer || [];
	        window.dataLayer.push({
	            event: 'v2_ppc_click',
	            ppcClickProperties: {
	                vendorID: vendor.id,
	                vendorSlug: vendor.slug,
	                advertisementId: vendor.advertisement_id,
	                categoryName: vendor.category && vendor.category.name
	            }
	        });
	    }
		};

/***/ }),

/***/ 662:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	var StoreFactory = __webpack_require__(516),
	    LocalStorage = __webpack_require__(445);

	module.exports = StoreFactory.create({
		displayName: 'Country',
		actions: ['add'],
		construct: function construct() {
			if (LocalStorage.get('user.origin')) {
				LocalStorage.remove('user.origin');
			}
			if (LocalStorage.get('user.origin.country')) {
				this.dispatch({
					type: 'COUNTRY_ADD',
					payload: LocalStorage.get('user.origin.country')
				});
			}
		},
		reducer: function reducer(state, action) {

			var dictionary = {};
			var countryList = [];

			switch (action.type) {
				case 'GEOLOCATION_DETECT_SUCCESS':
					if (action.payload.geoLocation.country.data.id) {

						LocalStorage.set('user.origin.country', action.payload.geoLocation.country.data);

						var obj = {},
						    _action$payload$geoLo = action.payload.geoLocation.country.data,
						    id = _action$payload$geoLo.id,
						    iso = _action$payload$geoLo.iso,
						    iso3 = _action$payload$geoLo.iso3,
						    name = _action$payload$geoLo.name,
						    nicename = _action$payload$geoLo.nicename,
						    numcode = _action$payload$geoLo.numcode,
						    phonecode = _action$payload$geoLo.phonecode,
						    slug = _action$payload$geoLo.slug;

						obj[action.payload.geoLocation.country.data.id] = { id: id, iso: iso, iso3: iso3, name: name, nicename: nicename, numcode: numcode, phonecode: phonecode, slug: slug };

						return Object.assign({}, state, obj);
					} else {
						return state;
					}

				case 'COUNTRY_ADD':
					if (action.payload.id) {
						var _obj = {},
						    _action$payload = action.payload,
						    _id = _action$payload.id,
						    _iso = _action$payload.iso,
						    _iso2 = _action$payload.iso3,
						    _name = _action$payload.name,
						    _nicename = _action$payload.nicename,
						    _numcode = _action$payload.numcode,
						    _phonecode = _action$payload.phonecode,
						    _slug = _action$payload.slug;

						_obj[action.payload.id] = { id: _id, iso: _iso, iso3: _iso2, name: _name, nicename: _nicename, numcode: _numcode, phonecode: _phonecode, slug: _slug };

						return Object.assign({}, state, {
							dictionary: Object.assign(state.dictionary, _obj)
						});
					} else {
						return state;
					}
				case 'COUNTRY_GET_COUNTRY_BY_SLUG_SUCCESS':
					return Object.assign({}, state, {
						dictionary: Object.assign(state.dictionary, _defineProperty({}, action.payload.countries.id, action.payload.countries))
					});
				case 'COUNTRY_FETCH_SERVICING_COUNTRIES_SUCCESS':

					action.payload.countries.map(function (country) {
						dictionary[country.id] = country;
						countryList.push(country.id);
					});

					return Object.assign({}, state, {
						dictionary: Object.assign({}, state.dictionary, dictionary),
						countryList: countryList,
						isLoaded: true
					});

				case 'COUNTRY_GET_HOMESTREAM_FILTER_COUNTRIES_SUCCESS':
					return Object.assign({}, state, {
						homestreamCountryList: action.payload.countries,
						isHomestreamCountriesLoaded: true
					});

				default:
					return state || {
						countryList: [],
						homestreamCountryList: [],
						dictionary: {},
						isLoaded: false,
						isHomestreamCountriesLoaded: false
					};
			}
		}
		});

/***/ }),

/***/ 669:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var ServiceFactory = __webpack_require__(484),
	    GeoLocationProvider = new (__webpack_require__(670))();

	module.exports = ServiceFactory.create({
		displayName: 'Geolocation',
		methods: {
			detect: GeoLocationProvider.detect
		}
		});

/***/ }),

/***/ 670:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var ApiService = __webpack_require__(486);

	var GeoLocation = function (_ApiService) {
		_inherits(GeoLocation, _ApiService);

		function GeoLocation(init) {
			var _ret;

			_classCallCheck(this, GeoLocation);

			var _this = _possibleConstructorReturn(this, (GeoLocation.__proto__ || Object.getPrototypeOf(GeoLocation)).call(this, init));

			return _ret = _this, _possibleConstructorReturn(_this, _ret);
		}

		_createClass(GeoLocation, [{
			key: 'detect',
			value: function detect(ip) {
				return this.get({
					url: 'v2/geo_location/detect',
					params: {
						clientIp: ip
					}
				});
			}
		}]);

		return GeoLocation;
	}(ApiService);

		module.exports = GeoLocation;

/***/ }),

/***/ 671:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var ComponentFactory = __webpack_require__(461),
	    React = __webpack_require__(1),
	    style = __webpack_require__(672),
	    Formsy = __webpack_require__(673);

	module.exports = ComponentFactory.create({
		displayName: 'Form',
		// methods : {
		// 	reset : function(){
		// 		this.refs.form.setFormPristine();
		// 		this.refs.form.reset();
		// 	}
		// },
		render: function render() {
			return React.createElement(
				Formsy.Form,
				_extends({ noValidate: true }, this.props, { ref: 'form' }),
				this.props.children
			);
		}
		});

/***/ }),

/***/ 672:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 673:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

	var PropTypes = __webpack_require__(201);
	var React = global.React || __webpack_require__(1);
	var createReactClass = __webpack_require__(674);
	var Formsy = {};
	var validationRules = __webpack_require__(675);
	var formDataToObject = __webpack_require__(676);
	var utils = __webpack_require__(677);
	var Mixin = __webpack_require__(678);
	var HOC = __webpack_require__(679);
	var Decorator = __webpack_require__(680);
	var options = {};
	var emptyArray = [];

	Formsy.Mixin = Mixin;
	Formsy.HOC = HOC;
	Formsy.Decorator = Decorator;

	Formsy.defaults = function (passedOptions) {
	  options = passedOptions;
	};

	Formsy.addValidationRule = function (name, func) {
	  validationRules[name] = func;
	};

	Formsy.Form = createReactClass({
	  displayName: 'Formsy',
	  getInitialState: function getInitialState() {
	    return {
	      isValid: true,
	      isSubmitting: false,
	      canChange: false
	    };
	  },
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onSuccess: function onSuccess() {},
	      onError: function onError() {},
	      onSubmit: function onSubmit() {},
	      onValidSubmit: function onValidSubmit() {},
	      onInvalidSubmit: function onInvalidSubmit() {},
	      onValid: function onValid() {},
	      onInvalid: function onInvalid() {},
	      onChange: function onChange() {},
	      validationErrors: null,
	      preventExternalInvalidation: false
	    };
	  },

	  childContextTypes: {
	    formsy: PropTypes.object
	  },
	  getChildContext: function getChildContext() {
	    var _this = this;

	    return {
	      formsy: {
	        attachToForm: this.attachToForm,
	        detachFromForm: this.detachFromForm,
	        validate: this.validate,
	        isFormDisabled: this.isFormDisabled,
	        isValidValue: function isValidValue(component, value) {
	          return _this.runValidation(component, value).isValid;
	        }
	      }
	    };
	  },

	  // Add a map to store the inputs of the form, a model to store
	  // the values of the form and register child inputs
	  componentWillMount: function componentWillMount() {
	    this.inputs = [];
	  },

	  componentDidMount: function componentDidMount() {
	    this.validateForm();
	  },

	  componentWillUpdate: function componentWillUpdate() {
	    // Keep a reference to input names before form updates,
	    // to check if inputs has changed after render
	    this.prevInputNames = this.inputs.map(function (component) {
	      return component.props.name;
	    });
	  },

	  componentDidUpdate: function componentDidUpdate() {

	    if (this.props.validationErrors && _typeof(this.props.validationErrors) === 'object' && Object.keys(this.props.validationErrors).length > 0) {
	      this.setInputValidationErrors(this.props.validationErrors);
	    }

	    var newInputNames = this.inputs.map(function (component) {
	      return component.props.name;
	    });
	    if (utils.arraysDiffer(this.prevInputNames, newInputNames)) {
	      this.validateForm();
	    }
	  },

	  // Allow resetting to specified data
	  reset: function reset(data) {
	    this.setFormPristine(true);
	    this.resetModel(data);
	  },

	  // Update model, submit to url prop and send the model
	  submit: function submit(event) {

	    event && event.preventDefault();

	    // Trigger form as not pristine.
	    // If any inputs have not been touched yet this will make them dirty
	    // so validation becomes visible (if based on isPristine)
	    this.setFormPristine(false);
	    var model = this.getModel();
	    this.props.onSubmit(model, this.resetModel, this.updateInputsWithError);
	    this.state.isValid ? this.props.onValidSubmit(model, this.resetModel, this.updateInputsWithError) : this.props.onInvalidSubmit(model, this.resetModel, this.updateInputsWithError);
	  },

	  mapModel: function mapModel(model) {

	    if (this.props.mapping) {
	      return this.props.mapping(model);
	    } else {
	      return formDataToObject.toObj(Object.keys(model).reduce(function (mappedModel, key) {

	        var keyArray = key.split('.');
	        var base = mappedModel;
	        while (keyArray.length) {
	          var currentKey = keyArray.shift();
	          base = base[currentKey] = keyArray.length ? base[currentKey] || {} : model[key];
	        }

	        return mappedModel;
	      }, {}));
	    }
	  },

	  getModel: function getModel() {
	    var currentValues = this.getCurrentValues();
	    return this.mapModel(currentValues);
	  },

	  // Reset each key in the model to the original / initial / specified value
	  resetModel: function resetModel(data) {
	    this.inputs.forEach(function (component) {
	      var name = component.props.name;
	      if (data && data.hasOwnProperty(name)) {
	        component.setValue(data[name]);
	      } else {
	        component.resetValue();
	      }
	    });
	    this.validateForm();
	  },

	  setInputValidationErrors: function setInputValidationErrors(errors) {
	    this.inputs.forEach(function (component) {
	      var name = component.props.name;
	      var args = [{
	        _isValid: !(name in errors),
	        _validationError: typeof errors[name] === 'string' ? [errors[name]] : errors[name]
	      }];
	      component.setState.apply(component, args);
	    });
	  },

	  // Checks if the values have changed from their initial value
	  isChanged: function isChanged() {
	    return !utils.isSame(this.getPristineValues(), this.getCurrentValues());
	  },

	  getPristineValues: function getPristineValues() {
	    return this.inputs.reduce(function (data, component) {
	      var name = component.props.name;
	      data[name] = component.props.value;
	      return data;
	    }, {});
	  },

	  // Go through errors from server and grab the components
	  // stored in the inputs map. Change their state to invalid
	  // and set the serverError message
	  updateInputsWithError: function updateInputsWithError(errors) {
	    var _this2 = this;

	    Object.keys(errors).forEach(function (name, index) {
	      var component = utils.find(_this2.inputs, function (component) {
	        return component.props.name === name;
	      });
	      if (!component) {
	        throw new Error('You are trying to update an input that does not exist. ' + 'Verify errors object with input names. ' + JSON.stringify(errors));
	      }
	      var args = [{
	        _isValid: _this2.props.preventExternalInvalidation || false,
	        _externalError: typeof errors[name] === 'string' ? [errors[name]] : errors[name]
	      }];
	      component.setState.apply(component, args);
	    });
	  },

	  isFormDisabled: function isFormDisabled() {
	    return this.props.disabled;
	  },

	  getCurrentValues: function getCurrentValues() {
	    return this.inputs.reduce(function (data, component) {
	      var name = component.props.name;
	      data[name] = component.state._value;
	      return data;
	    }, {});
	  },

	  setFormPristine: function setFormPristine(isPristine) {
	    this.setState({
	      _formSubmitted: !isPristine
	    });

	    // Iterate through each component and set it as pristine
	    // or "dirty".
	    this.inputs.forEach(function (component, index) {
	      component.setState({
	        _formSubmitted: !isPristine,
	        _isPristine: isPristine
	      });
	    });
	  },

	  // Use the binded values and the actual input value to
	  // validate the input and set its state. Then check the
	  // state of the form itself
	  validate: function validate(component) {

	    // Trigger onChange
	    if (this.state.canChange) {
	      this.props.onChange(this.getCurrentValues(), this.isChanged());
	    }

	    var validation = this.runValidation(component);
	    // Run through the validations, split them up and call
	    // the validator IF there is a value or it is required
	    component.setState({
	      _isValid: validation.isValid,
	      _isRequired: validation.isRequired,
	      _validationError: validation.error,
	      _externalError: null
	    }, this.validateForm);
	  },

	  // Checks validation on current value or a passed value
	  runValidation: function runValidation(component, value) {

	    var currentValues = this.getCurrentValues();
	    var validationErrors = component.props.validationErrors;
	    var validationError = component.props.validationError;
	    value = arguments.length === 2 ? value : component.state._value;

	    var validationResults = this.runRules(value, currentValues, component._validations);
	    var requiredResults = this.runRules(value, currentValues, component._requiredValidations);

	    // the component defines an explicit validate function
	    if (typeof component.validate === "function") {
	      validationResults.failed = component.validate() ? [] : ['failed'];
	    }

	    var isRequired = Object.keys(component._requiredValidations).length ? !!requiredResults.success.length : false;
	    var isValid = !validationResults.failed.length && !(this.props.validationErrors && this.props.validationErrors[component.props.name]);

	    return {
	      isRequired: isRequired,
	      isValid: isRequired ? false : isValid,
	      error: function () {

	        if (isValid && !isRequired) {
	          return emptyArray;
	        }

	        if (validationResults.errors.length) {
	          return validationResults.errors;
	        }

	        if (this.props.validationErrors && this.props.validationErrors[component.props.name]) {
	          return typeof this.props.validationErrors[component.props.name] === 'string' ? [this.props.validationErrors[component.props.name]] : this.props.validationErrors[component.props.name];
	        }

	        if (isRequired) {
	          var error = validationErrors[requiredResults.success[0]];
	          return error ? [error] : null;
	        }

	        if (validationResults.failed.length) {
	          return validationResults.failed.map(function (failed) {
	            return validationErrors[failed] ? validationErrors[failed] : validationError;
	          }).filter(function (x, pos, arr) {
	            // Remove duplicates
	            return arr.indexOf(x) === pos;
	          });
	        }
	      }.call(this)
	    };
	  },

	  runRules: function runRules(value, currentValues, validations) {

	    var results = {
	      errors: [],
	      failed: [],
	      success: []
	    };
	    if (Object.keys(validations).length) {
	      Object.keys(validations).forEach(function (validationMethod) {

	        if (validationRules[validationMethod] && typeof validations[validationMethod] === 'function') {
	          throw new Error('Formsy does not allow you to override default validations: ' + validationMethod);
	        }

	        if (!validationRules[validationMethod] && typeof validations[validationMethod] !== 'function') {
	          throw new Error('Formsy does not have the validation rule: ' + validationMethod);
	        }

	        if (typeof validations[validationMethod] === 'function') {
	          var validation = validations[validationMethod](currentValues, value);
	          if (typeof validation === 'string') {
	            results.errors.push(validation);
	            results.failed.push(validationMethod);
	          } else if (!validation) {
	            results.failed.push(validationMethod);
	          }
	          return;
	        } else if (typeof validations[validationMethod] !== 'function') {
	          var validation = validationRules[validationMethod](currentValues, value, validations[validationMethod]);
	          if (typeof validation === 'string') {
	            results.errors.push(validation);
	            results.failed.push(validationMethod);
	          } else if (!validation) {
	            results.failed.push(validationMethod);
	          } else {
	            results.success.push(validationMethod);
	          }
	          return;
	        }

	        return results.success.push(validationMethod);
	      });
	    }

	    return results;
	  },

	  // Validate the form by going through all child input components
	  // and check their state
	  validateForm: function validateForm() {
	    var _this3 = this;

	    // We need a callback as we are validating all inputs again. This will
	    // run when the last component has set its state
	    var onValidationComplete = function () {
	      var allIsValid = this.inputs.every(function (component) {
	        return component.state._isValid;
	      });

	      this.setState({
	        isValid: allIsValid
	      });

	      if (allIsValid) {
	        this.props.onValid();
	      } else {
	        this.props.onInvalid();
	      }

	      // Tell the form that it can start to trigger change events
	      this.setState({
	        canChange: true
	      });
	    }.bind(this);

	    // Run validation again in case affected by other inputs. The
	    // last component validated will run the onValidationComplete callback
	    this.inputs.forEach(function (component, index) {
	      var validation = _this3.runValidation(component);
	      if (validation.isValid && component.state._externalError) {
	        validation.isValid = false;
	      }
	      component.setState({
	        _isValid: validation.isValid,
	        _isRequired: validation.isRequired,
	        _validationError: validation.error,
	        _externalError: !validation.isValid && component.state._externalError ? component.state._externalError : null
	      }, index === _this3.inputs.length - 1 ? onValidationComplete : null);
	    });

	    // If there are no inputs, set state where form is ready to trigger
	    // change event. New inputs might be added later
	    if (!this.inputs.length) {
	      this.setState({
	        canChange: true
	      });
	    }
	  },

	  // Method put on each input component to register
	  // itself to the form
	  attachToForm: function attachToForm(component) {

	    if (this.inputs.indexOf(component) === -1) {
	      this.inputs.push(component);
	    }

	    this.validate(component);
	  },

	  // Method put on each input component to unregister
	  // itself from the form
	  detachFromForm: function detachFromForm(component) {
	    var componentPos = this.inputs.indexOf(component);

	    if (componentPos !== -1) {
	      this.inputs = this.inputs.slice(0, componentPos).concat(this.inputs.slice(componentPos + 1));
	    }

	    this.validateForm();
	  },
	  render: function render() {
	    var _props = this.props,
	        mapping = _props.mapping,
	        validationErrors = _props.validationErrors,
	        onSubmit = _props.onSubmit,
	        onValid = _props.onValid,
	        onValidSubmit = _props.onValidSubmit,
	        onInvalid = _props.onInvalid,
	        onInvalidSubmit = _props.onInvalidSubmit,
	        onChange = _props.onChange,
	        reset = _props.reset,
	        preventExternalInvalidation = _props.preventExternalInvalidation,
	        onSuccess = _props.onSuccess,
	        onError = _props.onError,
	        nonFormsyProps = _objectWithoutProperties(_props, ['mapping', 'validationErrors', 'onSubmit', 'onValid', 'onValidSubmit', 'onInvalid', 'onInvalidSubmit', 'onChange', 'reset', 'preventExternalInvalidation', 'onSuccess', 'onError']);

	    return React.createElement(
	      'form',
	      _extends({}, nonFormsyProps, { onSubmit: this.submit }),
	      this.props.children
	    );
	  }
	});

	if (!global.exports && !global.module && (!global.define || !global.define.amd)) {
	  global.Formsy = Formsy;
	}

	module.exports = Formsy;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 674:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */

	'use strict';

	var React = __webpack_require__(1);
	var factory = __webpack_require__(32);

	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}

	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;

	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),

/***/ 675:
/***/ (function(module, exports) {

	'use strict';

	var _isExisty = function _isExisty(value) {
	  return value !== null && value !== undefined;
	};

	var isEmpty = function isEmpty(value) {
	  return value === '';
	};

	var validations = {
	  isDefaultRequiredValue: function isDefaultRequiredValue(values, value) {
	    return value === undefined || value === '';
	  },
	  isExisty: function isExisty(values, value) {
	    return _isExisty(value);
	  },
	  matchRegexp: function matchRegexp(values, value, regexp) {
	    return !_isExisty(value) || isEmpty(value) || regexp.test(value);
	  },
	  isUndefined: function isUndefined(values, value) {
	    return value === undefined;
	  },
	  isEmptyString: function isEmptyString(values, value) {
	    return isEmpty(value);
	  },
	  isEmail: function isEmail(values, value) {
	    return validations.matchRegexp(values, value, /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i);
	  },
	  isUrl: function isUrl(values, value) {
	    return validations.matchRegexp(values, value, /^(https?|s?ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i);
	  },
	  isTrue: function isTrue(values, value) {
	    return value === true;
	  },
	  isFalse: function isFalse(values, value) {
	    return value === false;
	  },
	  isNumeric: function isNumeric(values, value) {
	    if (typeof value === 'number') {
	      return true;
	    }
	    return validations.matchRegexp(values, value, /^[-+]?(?:\d*[.])?\d+$/);
	  },
	  isAlpha: function isAlpha(values, value) {
	    return validations.matchRegexp(values, value, /^[A-Z]+$/i);
	  },
	  isAlphanumeric: function isAlphanumeric(values, value) {
	    return validations.matchRegexp(values, value, /^[0-9A-Z]+$/i);
	  },
	  isInt: function isInt(values, value) {
	    return validations.matchRegexp(values, value, /^(?:[-+]?(?:0|[1-9]\d*))$/);
	  },
	  isFloat: function isFloat(values, value) {
	    return validations.matchRegexp(values, value, /^(?:[-+]?(?:\d+))?(?:\.\d*)?(?:[eE][\+\-]?(?:\d+))?$/);
	  },
	  isWords: function isWords(values, value) {
	    return validations.matchRegexp(values, value, /^[A-Z\s]+$/i);
	  },
	  isSpecialWords: function isSpecialWords(values, value) {
	    return validations.matchRegexp(values, value, /^[A-Z\s\u00C0-\u017F]+$/i);
	  },
	  isLength: function isLength(values, value, length) {
	    return !_isExisty(value) || isEmpty(value) || value.length === length;
	  },
	  equals: function equals(values, value, eql) {
	    return !_isExisty(value) || isEmpty(value) || value == eql;
	  },
	  equalsField: function equalsField(values, value, field) {
	    return value == values[field];
	  },
	  maxLength: function maxLength(values, value, length) {
	    return !_isExisty(value) || value.length <= length;
	  },
	  minLength: function minLength(values, value, length) {
	    return !_isExisty(value) || isEmpty(value) || value.length >= length;
	  }
	};

	module.exports = validations;

/***/ }),

/***/ 676:
/***/ (function(module, exports) {

	function toObj(source) {
	  return Object.keys(source).reduce(function (output, key) {
	    var parentKey = key.match(/[^\[]*/i);
	    var paths = key.match(/\[.*?\]/g) || [];
	    paths = [parentKey[0]].concat(paths).map(function (key) {
	      return key.replace(/\[|\]/g, '');
	    });
	    var currentPath = output;
	    while (paths.length) {
	      var pathKey = paths.shift();

	      if (pathKey in currentPath) {
	        currentPath = currentPath[pathKey];
	      } else {
	        currentPath[pathKey] = paths.length ? isNaN(paths[0]) ? {} : [] : source[key];
	        currentPath = currentPath[pathKey];
	      }
	    }

	    return output;
	  }, {});
	}

	function fromObj(obj) {
	  function recur(newObj, propName, currVal) {
	    if (Array.isArray(currVal) || Object.prototype.toString.call(currVal) === '[object Object]') {
	      Object.keys(currVal).forEach(function(v) {
	        recur(newObj, propName + "[" + v + "]", currVal[v]);
	      });
	      return newObj;
	    }

	    newObj[propName] = currVal;
	    return newObj;
	  }

	  var keys = Object.keys(obj);
	  return keys.reduce(function(newObj, propName) {
	    return recur(newObj, propName, obj[propName]);
	  }, {});
	}

	module.exports = {
	  fromObj: fromObj,
	  toObj: toObj
	}

/***/ }),

/***/ 677:
/***/ (function(module, exports) {

	'use strict';

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	module.exports = {
	  arraysDiffer: function arraysDiffer(a, b) {
	    var isDifferent = false;
	    if (a.length !== b.length) {
	      isDifferent = true;
	    } else {
	      a.forEach(function (item, index) {
	        if (!this.isSame(item, b[index])) {
	          isDifferent = true;
	        }
	      }, this);
	    }
	    return isDifferent;
	  },

	  objectsDiffer: function objectsDiffer(a, b) {
	    var isDifferent = false;
	    if (Object.keys(a).length !== Object.keys(b).length) {
	      isDifferent = true;
	    } else {
	      Object.keys(a).forEach(function (key) {
	        if (!this.isSame(a[key], b[key])) {
	          isDifferent = true;
	        }
	      }, this);
	    }
	    return isDifferent;
	  },

	  isSame: function isSame(a, b) {
	    if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) !== (typeof b === 'undefined' ? 'undefined' : _typeof(b))) {
	      return false;
	    } else if (Array.isArray(a) && Array.isArray(b)) {
	      return !this.arraysDiffer(a, b);
	    } else if (typeof a === 'function') {
	      return a.toString() === b.toString();
	    } else if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object' && a !== null && b !== null) {
	      return !this.objectsDiffer(a, b);
	    }

	    return a === b;
	  },

	  find: function find(collection, fn) {
	    for (var i = 0, l = collection.length; i < l; i++) {
	      var item = collection[i];
	      if (fn(item)) {
	        return item;
	      }
	    }
	    return null;
	  }
	};

/***/ }),

/***/ 678:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';

	var PropTypes = __webpack_require__(201);
	var utils = __webpack_require__(677);
	var React = global.React || __webpack_require__(1);

	var convertValidationsToObject = function convertValidationsToObject(validations) {

	  if (typeof validations === 'string') {

	    return validations.split(/\,(?![^{\[]*[}\]])/g).reduce(function (validations, validation) {
	      var args = validation.split(':');
	      var validateMethod = args.shift();

	      args = args.map(function (arg) {
	        try {
	          return JSON.parse(arg);
	        } catch (e) {
	          return arg; // It is a string if it can not parse it
	        }
	      });

	      if (args.length > 1) {
	        throw new Error('Formsy does not support multiple args on string validations. Use object format of validations instead.');
	      }

	      validations[validateMethod] = args.length ? args[0] : true;
	      return validations;
	    }, {});
	  }

	  return validations || {};
	};

	module.exports = {
	  getInitialState: function getInitialState() {
	    return {
	      _value: this.props.value,
	      _isRequired: false,
	      _isValid: true,
	      _isPristine: true,
	      _pristineValue: this.props.value,
	      _validationError: [],
	      _externalError: null,
	      _formSubmitted: false
	    };
	  },
	  contextTypes: {
	    formsy: PropTypes.object // What about required?
	  },
	  getDefaultProps: function getDefaultProps() {
	    return {
	      validationError: '',
	      validationErrors: {}
	    };
	  },

	  componentWillMount: function componentWillMount() {
	    var configure = function () {
	      this.setValidations(this.props.validations, this.props.required);

	      // Pass a function instead?
	      this.context.formsy.attachToForm(this);
	      //this.props._attachToForm(this);
	    }.bind(this);

	    if (!this.props.name) {
	      throw new Error('Form Input requires a name property when used');
	    }

	    /*
	    if (!this.props._attachToForm) {
	      return setTimeout(function () {
	        if (!this.isMounted()) return;
	        if (!this.props._attachToForm) {
	          throw new Error('Form Mixin requires component to be nested in a Form');
	        }
	        configure();
	      }.bind(this), 0);
	    }
	    */
	    configure();
	  },

	  // We have to make the validate method is kept when new props are added
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    this.setValidations(nextProps.validations, nextProps.required);
	  },

	  componentDidUpdate: function componentDidUpdate(prevProps) {

	    // If the value passed has changed, set it. If value is not passed it will
	    // internally update, and this will never run
	    if (!utils.isSame(this.props.value, prevProps.value)) {
	      this.setValue(this.props.value);
	    }

	    // If validations or required is changed, run a new validation
	    if (!utils.isSame(this.props.validations, prevProps.validations) || !utils.isSame(this.props.required, prevProps.required)) {
	      this.context.formsy.validate(this);
	    }
	  },

	  // Detach it when component unmounts
	  componentWillUnmount: function componentWillUnmount() {
	    this.context.formsy.detachFromForm(this);
	    //this.props._detachFromForm(this);
	  },

	  setValidations: function setValidations(validations, required) {

	    // Add validations to the store itself as the props object can not be modified
	    this._validations = convertValidationsToObject(validations) || {};
	    this._requiredValidations = required === true ? { isDefaultRequiredValue: true } : convertValidationsToObject(required);
	  },

	  // We validate after the value has been set
	  setValue: function setValue(value) {
	    this.setState({
	      _value: value,
	      _isPristine: false
	    }, function () {
	      this.context.formsy.validate(this);
	      //this.props._validate(this);
	    }.bind(this));
	  },
	  resetValue: function resetValue() {
	    this.setState({
	      _value: this.state._pristineValue,
	      _isPristine: true
	    }, function () {
	      this.context.formsy.validate(this);
	      //this.props._validate(this);
	    });
	  },
	  getValue: function getValue() {
	    return this.state._value;
	  },
	  hasValue: function hasValue() {
	    return this.state._value !== '';
	  },
	  getErrorMessage: function getErrorMessage() {
	    var messages = this.getErrorMessages();
	    return messages.length ? messages[0] : null;
	  },
	  getErrorMessages: function getErrorMessages() {
	    return !this.isValid() || this.showRequired() ? this.state._externalError || this.state._validationError || [] : [];
	  },
	  isFormDisabled: function isFormDisabled() {
	    return this.context.formsy.isFormDisabled();
	    //return this.props._isFormDisabled();
	  },
	  isValid: function isValid() {
	    return this.state._isValid;
	  },
	  isPristine: function isPristine() {
	    return this.state._isPristine;
	  },
	  isFormSubmitted: function isFormSubmitted() {
	    return this.state._formSubmitted;
	  },
	  isRequired: function isRequired() {
	    return !!this.props.required;
	  },
	  showRequired: function showRequired() {
	    return this.state._isRequired;
	  },
	  showError: function showError() {
	    return !this.showRequired() && !this.isValid();
	  },
	  isValidValue: function isValidValue(value) {
	    return this.context.formsy.isValidValue.call(null, this, value);
	    //return this.props._isValidValue.call(null, this, value);
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 679:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var React = global.React || __webpack_require__(1);
	var createReactClass = __webpack_require__(674);
	var Mixin = __webpack_require__(678);
	module.exports = function (Component) {
	  return createReactClass({
	    displayName: 'Formsy(' + getDisplayName(Component) + ')',
	    mixins: [Mixin],

	    render: function render() {
	      var innerRef = this.props.innerRef;

	      var propsForElement = _extends({
	        setValidations: this.setValidations,
	        setValue: this.setValue,
	        resetValue: this.resetValue,
	        getValue: this.getValue,
	        hasValue: this.hasValue,
	        getErrorMessage: this.getErrorMessage,
	        getErrorMessages: this.getErrorMessages,
	        isFormDisabled: this.isFormDisabled,
	        isValid: this.isValid,
	        isPristine: this.isPristine,
	        isFormSubmitted: this.isFormSubmitted,
	        isRequired: this.isRequired,
	        showRequired: this.showRequired,
	        showError: this.showError,
	        isValidValue: this.isValidValue
	      }, this.props);

	      if (innerRef) {
	        propsForElement.ref = innerRef;
	      }
	      return React.createElement(Component, propsForElement);
	    }
	  });
	};

	function getDisplayName(Component) {
	  return Component.displayName || Component.name || (typeof Component === 'string' ? Component : 'Component');
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 680:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var React = global.React || __webpack_require__(1);
	var createReactClass = __webpack_require__(674);
	var Mixin = __webpack_require__(678);
	module.exports = function () {
	  return function (Component) {
	    return createReactClass({
	      mixins: [Mixin],
	      render: function render() {
	        return React.createElement(Component, _extends({
	          setValidations: this.setValidations,
	          setValue: this.setValue,
	          resetValue: this.resetValue,
	          getValue: this.getValue,
	          hasValue: this.hasValue,
	          getErrorMessage: this.getErrorMessage,
	          getErrorMessages: this.getErrorMessages,
	          isFormDisabled: this.isFormDisabled,
	          isValid: this.isValid,
	          isPristine: this.isPristine,
	          isFormSubmitted: this.isFormSubmitted,
	          isRequired: this.isRequired,
	          showRequired: this.showRequired,
	          showError: this.showError,
	          isValidValue: this.isValidValue
	        }, this.props));
	      }
	    });
	  };
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 731:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var Localizer = __webpack_require__(443);

	module.exports = new Localizer(['modules/components/login/popup/index', function () {
		return __webpack_require__(732);
	}]);

/***/ }),

/***/ 732:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var ComponentFactory = __webpack_require__(461),
	    React = __webpack_require__(1),
	    loginstyle = __webpack_require__(733),
	    LoginForm = __webpack_require__(734);

	module.exports = ComponentFactory.create({
		displayName: 'LoginPopupDesktop',
		methods: {
			onForgot: function onForgot(e) {
				e.preventDefault();

				this.context.parent && this.context.parent.onForgot();
			},
			onTermsConditions: function onTermsConditions(e) {
				e.preventDefault();

				this.context.popup && this.context.popup.add(PopupTermCondition, {
					overrideLogin: true
				});
			},
			closePopup: function closePopup(e) {
				e.preventDefault();

				console.log('Close Clicked');

				this.context.popup && this.context.popup.dismissLast();
			},
			__render_title__: function __render_title__(type) {
				switch (type) {
					case 'inspiration':
						return this.translator.toHTML('login.popup_title_origin_inspiration');
					case 'comment':
						return this.translator.toHTML('login.popup_title_origin_comment');
					case 'saving':
						return this.translator.toHTML('login.popup_title_origin_save');
					case 'message':
						return this.translator.toHTML('login.popup_title_origin_message');
					case 'lead':
						return this.translator.toHTML('login.popup_title_origin_leads');
					case 'review':
						return this.translator.toHTML('login.popup_title_origin_review');
					case 'pricelist':
						return this.translator.toHTML('login.popup_title_origin_askforpricelist');
					case 'notitle':
						return this.translator.toHTML('general.label_welcome_to_bridestory');
					default:
						return this.translator.toHTML('login.popup_label_title');
				}
			},
			__render_subtitle__: function __render_subtitle__(type) {
				switch (type) {
					case 'inspiration':
					case 'comment':
					case 'saving':
					case 'message':
					case 'lead':
					case 'review':
					case 'pricelist':
						return this.translator.toHTML('login.popup_label_subtitle_2');
					case 'notitle':
						return this.translator.toHTML('general.label_welcome_description');
					default:
						return this.translator.toHTML('login.popup_label_subtitle_1');
				}
			}
		},
		render: function render() {
			var _this = this;

			return React.createElement(
				'div',
				{ className: 'col col-8 bg-c-background-secondary login-popup-h' },
				function () {
					if (_this.props.title == 'notitle') return React.createElement(
						'div',
						{ className: 'right popup-close f-b-24' },
						React.createElement('span', { className: 'icon-close-filled', onClick: _this.closePopup.bind(_this) })
					);
				}(),
				React.createElement(
					'div',
					{ className: 'wrapper-block middle-transform' },
					React.createElement(
						'div',
						{ className: 'f-tac row row-no-gutter' },
						React.createElement(
							'div',
							{ className: 'col col-9 wrapper' },
							function () {
								if (_this.props.title != 'notitle') return React.createElement(
									'div',
									{ className: 'pb-15' },
									React.createElement('span', { className: 'icons-logo-medium', title: 'Bridestory' })
								);
							}(),
							React.createElement(
								'h3',
								{ className: 'f-p-13 semibold f-c-text-secondary' },
								this.translator.toHTML('login.popup_label_title')
							),
							React.createElement(
								'p',
								{ className: 'f-p-13 mb-20 mt-10' },
								this.translator.toHTML('login.popup_label_subtitle_1', { registerurl: '/register' })
							),
							React.createElement(LoginForm, null),
							React.createElement(
								'p',
								{ className: 'pt-10' },
								React.createElement(
									'a',
									{ className: 'f-p-12 f-t-u mt-15', target: '_self', href: this.getLink('forgotpassword') },
									this.translator.toHTML('login.login_link_forgot')
								)
							),
							React.createElement(
								'p',
								{ className: 'f-p-13 mt-25' },
								this.translator.toHTML('login.create_account_text_bottom')
							)
						)
					)
				)
			);
		}
		});

/***/ }),

/***/ 733:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 734:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var Google = __webpack_require__(735);

	var ComponentFactory = __webpack_require__(461),
	    React = __webpack_require__(1),
	    style = __webpack_require__(736),
	    AuthService = __webpack_require__(483),
	    GeoLocation = __webpack_require__(669),
	    UserService = __webpack_require__(519),
	    UserStore = __webpack_require__(515),
	    ChatService = __webpack_require__(636),
	    NotificationService = __webpack_require__(638),
	    GoogleStore = __webpack_require__(735),
	    CountryStore = __webpack_require__(662),
	    RegistrationStore = __webpack_require__(737),
	    Form = __webpack_require__(671),
	    Input = __webpack_require__(738),
	    Button = __webpack_require__(681),
	    PopupTermCondition = __webpack_require__(739),
	    CommonHelper = __webpack_require__(210),
	    DatalayerHelper = __webpack_require__(645),
	    GoogleSDK = __webpack_require__(744),
	    Cookie = CommonHelper.isWindow() ? __webpack_require__(446) : undefined;

	module.exports = ComponentFactory.create({
		displayName: 'LoginForm',
		construct: function construct(_ref) {
			var props = _ref.props,
			    context = _ref.context;

			this.state = {
				buttonState: ''
			};
		},
		componentDidMount: function componentDidMount() {
			this.AuthService = this.context.manager.addService(AuthService);
			this.UserService = this.context.manager.addService(UserService);
			this.ChatService = this.context.manager.addService(ChatService);
			this.NotificationService = this.context.manager.addService(NotificationService);

			this.context.manager.addStore(UserStore);
			this.context.manager.addStore(CountryStore);
			this.context.manager.addStore(GoogleStore);
			this.initGoogle();
		},
		methods: {
			getCountryOfOrigin: function getCountryOfOrigin() {
				var _this2 = this;

				this.context.manager.addService(GeoLocation).detect().then(function (res) {
					_this2.context.manager.services.geolocation.dispatch({
						type: 'USER_COUNTRY_OF_ORIGIN',
						payload: res.geoLocation.country.data.id
					});
				});
			},
			trackLogin: function trackLogin(attr, fail, success) {
				var user_id = 0;
				var country = null;
				var email = '';
				var mobile_no = 0;

				if (attr && attr.user) {
					if (attr.user.contacts && attr.user.contacts.data.length) {
						mobile_no = attr.user.contacts.data.find(function (c) {
							return c.name.toLowerCase() == 'mobile';
						});
						mobile_no = mobile_no.detail.replace(/ /g, '');
					}

					var firstName = attr.user.fullName.split(' ')[0];
					var lastName = attr.user.fullName.split(' ').slice(1).join(' ');

					user_id = attr.user.id;
					country = attr.user.countryOfOrigin && attr.user.countryOfOrigin.data.name;
					email = attr.user.account.data.email;
				}
			},
			loginCallback: function loginCallback(result) {
				var _this3 = this;

				var _this = this;
				_this.props.dispatchUserLogin(result);
				setTimeout(function () {
					// _this.UserService.getTotalUnreadMessages();
					var _uuid = result.user && result.user.account.data.uuid || result.vendor.account.data.uuid,
					    _accountId = result.user && result.user.accountId;

					_this.UserService.getUserHildaStatus().then(function (response) {
						if (response.hilda && response.hilda.bwcUser && response.hilda.bwcUser.data.uuid) {
							_this.ChatService.getHildaMessageUnreadCount({
								uuid: response.hilda.bwcUser.data.uuid
							});
						}
					});

					_this.ChatService.getMessageUnreadCount({
						uuid: _uuid
					});

					_this3.trackLogin(result, '', true);

					_this.NotificationService.getNotificationUnreadCount(_accountId);
					_this.UserService.getWeddingPoints().then(function (response) {
						_this3.manager.dispatch({
							type: 'WEDDING_POINTS_GET_SUCCESS',
							payload: response
						});
					});
				}, 200);
			},
			googleLogin: function googleLogin() {
				return window.google_auth2.requestAccessToken();
			},
			initGoogle: function initGoogle() {
				var _this = this;

				var authGoogle = function authGoogle(tokenRespons) {
					var payload = {
						type: 'google',
						promotionalNewsletter: true,
						access_token: tokenRespons.access_token || null
					};

					_this.setState({
						buttonState: 'btn-loading'
					});

					_this.AuthService.socmedLogin(payload).then(function (result) {
						if (result.status) {
							_this.context.manager.addStore(RegistrationStore);
							_this.props.dispatchRegister({
								fullName: response.name,
								email: response.email || '',
								socmedId: response.id,
								type: 'google',
								access_token: tokenRespons.access_token
							});
							_this.context.parent.onSignUpGoogle && _this.context.parent.onSignUpGoogle();
						} else {
							//REGISTERED
							DatalayerHelper.auth('v2_sign_in', 'google', result);

							_this.loginCallback(result);

							_this.setState({
								buttonState: 'btn-redirecting'
							});

							_this.context.parent.onLoginSuccess && _this.context.parent.onLoginSuccess();
						}
					});
				};

				try {
					GoogleSDK.default(authGoogle);
				} catch (error) {
					console.error(error, 'err');
				}
			},
			onInvalidLogin: function onInvalidLogin(data, resetter, invalidate) {
				var _this4 = this;

				if (this.state.isReturnInvalid) {
					this.setState({
						isReturnInvalid: false
					}, function () {
						var _email = _this4.refs.email,
						    _form = _this4.refs.myform.refs.form;

						_email.setValue(_email.getValue());

						setTimeout(function () {
							_form.submit();
						}, 0);
					});
				}
			},
			basicLogin: function basicLogin(data, resetter, invalidate) {
				var _this5 = this;

				if (this.state.buttonState === 'btn-loading') return;

				this.setState({
					buttonState: 'btn-loading'
				});

				//OR you can call it by displayName : this.context.manager.services.authenticate
				this.AuthService.basicLogin({
					email: data.email,
					password: data.password
				}).then(function (result) {
					if (result.status) {
						_this5.setState({
							buttonState: ''
						});
						if (result.status === 401) {
							if (result.code === 5) {
								invalidate({
									email: '',
									password: _this5.translator.toText('login.login_label_email_and_password_dont_match') //result.message
								});

								_this5.setState({
									isReturnInvalid: true
								});
							} else if (result.code === 4) {
								//CHANGE ROUTE TO REGISTER
								_this5.context.manager.addStore(RegistrationStore);
								_this5.props.dispatchRegister({ email: data.email, password: data.password });
								_this5.context.parent.onSignUpBasic && _this5.context.parent.onSignUpBasic();
							}
							_this5.trackLogin(null, result.message, false);
						} else {
							//TODO : TOPBAR NOTIFY SOMETHING WRONG
						}
					} else {

						if (result.user && result.user.account.data.isVerified == 0) {
							_this5.setState({
								buttonState: ''
							});
							Cookie.set('BS.verification', JSON.stringify({
								token: result.user.sessionId,
								time: null,
								email: result.user.account.data.email
							}), {
								domain: '.bridestory.com',
								path: '/',
								expires: 1
							});
							var path = '/verification?redirect_uri=' + window.location.pathname;
							window.location.pathname = path;
							// this.context.manager.addStore(RegistrationStore);
							// this.props.dispatchRegister({email : data.email})

							// //CHANGE ROUTE TO VERIFICATION
							// this.context.parent.onVerify &&
							// this.context.parent.onVerify();
							//TODO : TOPBAR NOTIFY
						} else {

							DatalayerHelper.auth('v2_sign_in', 'form', result);

							_this5.loginCallback(result);

							resetter();

							_this5.setState({
								buttonState: 'btn-redirecting'
							});

							_this5.context.parent.onLoginSuccess && _this5.context.parent.onLoginSuccess();

							Cookie.remove('BS.RedirectURL', { domain: '.bridestory.com', path: '/' });
						}
					}
					return result;
				});
			},
			onTermsConditions: function onTermsConditions(e) {
				e.preventDefault();

				this.context.popup && this.context.popup.add(PopupTermCondition, {
					overrideLogin: true
				});
			}
		},
		dispatchToProps: function dispatchToProps(dispatch) {
			return {
				dispatchRegister: function dispatchRegister(payload) {
					dispatch({
						type: RegistrationStore.ACTIONS.REGISTRATION_REGISTER,
						payload: payload
					});
				},
				dispatchUserLogin: function dispatchUserLogin(result) {
					//ADD RECOGNIZED COUNTRY
					dispatch({
						type: CountryStore.ACTIONS.COUNTRY_ADD,
						payload: result.user && result.user.countryOfOrigin.data || result.vendor.countryOfOrigin.data
					});

					//NOTIFY USER STORE
					dispatch({
						type: UserStore.ACTIONS.USER_LOGIN,
						payload: result
					});

					dispatch({
						type: 'PAGECOUNT_SET',
						payload: 1
					});
				}
			};
		},
		stateToProps: function stateToProps(state) {
			return {
				googleInit: state.google && state.google.init
			};
		},
		render: function render() {
			return React.createElement(
				'div',
				null,
				React.createElement(
					'div',
					{ className: 'row sosmed-connect mt-15 mb-25 f-tac' },
					React.createElement(
						'div',
						{ className: 'col col-12' },
						React.createElement(
							Button,
							{ onClick: this.googleLogin.bind(this), className: 'btn-block btn-google ready' },
							React.createElement(
								'span',
								{ className: 'icon-brand-google left' },
								React.createElement('span', { className: 'loginform-right-bar' })
							),
							'Google'
						)
					)
				),
				React.createElement(
					'div',
					{ className: 'loginform-or f-b-12' },
					this.translator.toHTML('login.login_str_or')
				),
				React.createElement(
					Form,
					{ className: 'form', onValidSubmit: this.basicLogin.bind(this), onInvalidSubmit: this.onInvalidLogin.bind(this), ref: 'myform' },
					React.createElement(
						'div',
						{ className: 'row' },
						React.createElement(Input, { type: 'email', name: 'email', tabIndex: '1', placeholder: this.translator.toText('login.login_placeholder_email'),
							validations: 'isEmail',
							validationErrors: { isEmail: this.translator.toText('login.login_label_wrong_email'), isDefaultRequiredValue: this.translator.toText('login.login_label_no_email') },
							ref: 'email',
							required: true })
					),
					React.createElement(
						'div',
						{ className: 'row' },
						React.createElement(Input, { type: 'password', name: 'password', tabIndex: '2', placeholder: this.translator.toText('general.label_password'), validations: 'minLength:6', validationErrors: { isDefaultRequiredValue: this.translator.toText('login.login_label_password_too_short'), minLength: this.translator.toText('login.login_label_password_too_short') }, required: true })
					),
					React.createElement(
						'div',
						{ className: 'row' },
						React.createElement(
							'div',
							{ className: 'col col-6 create-btn wrapper pt-10' },
							React.createElement(
								Button,
								{ asButton: true, className: 'btn-submit btn-block ' + this.state.buttonState },
								this.translator.toHTML('login.button_continue')
							)
						)
					)
				)
			);
		}
		});

/***/ }),

/***/ 735:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var StoreFactory = __webpack_require__(516),
	    LocalStorage = __webpack_require__(445),
	    CommonHelper = __webpack_require__(210),
	    Q = __webpack_require__(441),
	    Config = __webpack_require__(340);

	module.exports = StoreFactory.create({
		displayName: 'Google',
		actions: ['init', 'login_status', 'response', 'user_data'],
		methods: {
			__login: function __login(defer) {
				var _this = this;

				this.GoogleAuth.signIn().then(function (result) {
					var userdata = _this.GoogleAuth.currentUser.get();
					_this.dispatch({
						type: 'GOOGLE_LOGIN_STATUS',
						payload: true
					});

					_this.dispatch({
						type: 'GOOGLE_RESPONSE',
						payload: result
					});

					defer && defer.resolve(userdata);
				}, function (error) {
					//TODO : NOTIFICATION ERROR
					defer && defer.reject(error);
				});
			},
			login: function login() {
				var _this2 = this;

				return Q.suspend(function (defer) {
					if (_this2.state.init === 'ready') {
						if (_this2.state.loginStatus === false) {
							if (_this2.onInit) {
								_this2.onInit(defer);
							} else {
								_this2.__login(defer);
							}
						} else if (_this2.state.loginStatus === 'connected' || _this2.state.loginStatus === true) {
							defer.resolve(_this2.state.response);
						}
					} else {
						var _defer = defer;
						_this2.onInit = function (defer) {
							_this2.__login(_defer);
						};
					}
				});
			},
			getUserData: function getUserData() {
				var _this3 = this;

				return Q.suspend(function (defer) {
					if (_this3.state.init === 'ready' && _this3.state.loginStatus === true) {
						var profile = _this3.GoogleAuth.currentUser.get();
						var userdata = profile.getBasicProfile();
						var accessToken = profile.getAuthResponse(true).access_token;

						userdata = {
							id: userdata.getId(),
							name: userdata.getName(),
							email: userdata.getEmail(),
							access_token: accessToken || null
						};

						_this3.dispatch({
							type: 'GOOGLE_LOGIN_STATUS',
							payload: true
						});

						_this3.dispatch({
							type: 'GOOGLE_USER_DATA',
							payload: userdata
						});

						defer.resolve(userdata);
					} else {
						defer.reject('Login first!');
					}
				});
			}
		},
		construct: function construct() {
			var _this4 = this;

			this.GoogleAuth;

			if (CommonHelper.isWindow() && this.state.init !== 'ready') {
				if (this.state.init === false) {
					this.dispatch({
						type: 'GOOGLE_INIT',
						payload: 'pending'
					});

					window.googleAsyncInit = function () {
						gapi.load('auth2', function () {
							_this4.GoogleAuth = google.accounts.oauth2.initTokenClient({
								client_id: Config.googleClientId,
								scope: 'https://www.googleapis.com/auth/userinfo.email',
								callback: function (_callback) {
									function callback(_x) {
										return _callback.apply(this, arguments);
									}

									callback.toString = function () {
										return _callback.toString();
									};

									return callback;
								}(function (tokenResponse) {
									if (callback) callback(tokenResponse);
								})
							});

							_this4.dispatch({
								type: 'GOOGLE_LOGIN_STATUS',
								payload: _this4.GoogleAuth.isSignedIn.get()
							});

							_this4.dispatch({
								type: 'GOOGLE_INIT',
								payload: 'ready'
							});

							_this4.onInit && typeof _this4.onInit === 'function' && _this4.onInit();
						});
					};

					//LOAD THE SDK
					(function (d, s, id) {
						var js,
						    fjs = d.getElementsByTagName(s)[0];
						if (d.getElementById(id)) return;
						js = d.createElement(s);js.id = id;
						js.src = 'https://accounts.google.com/gsi/client';
						fjs.parentNode.insertBefore(js, fjs);
					})(document, 'script', 'google-jssdk');
				}
			}
		},
		reducer: function reducer(state, action) {
			switch (action.type) {
				case 'GOOGLE_USER_DATA':
					return Object.assign({}, state, {
						user: action.payload
					});

				case 'GOOGLE_RESPONSE':
					return Object.assign({}, state, {
						response: action.payload
					});

				case 'GOOGLE_LOGIN_STATUS':
					return Object.assign({}, state, {
						loginStatus: action.payload
					});

				case 'GOOGLE_INIT':
					return Object.assign({}, state, {
						init: action.payload
					});

				default:
					return state || {
						init: false,
						loginStatus: false,
						response: false,
						user: false
					};
			}
		}
		});

/***/ }),

/***/ 736:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 737:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var StoreFactory = __webpack_require__(516);

	module.exports = StoreFactory.create({
		displayName: 'Registration',
		actions: ['register', 'promotional_newsletter'],
		reducer: function reducer(state, action) {
			switch (action.type) {
				case 'REGISTRATION_REGISTER':
					return Object.assign({}, state, action.payload);

				case 'REGISTRATION_TYPE':
					return Object.assign({}, state, {
						type: action.payload
					});

				case 'REGISTRATION_PROMOTIONAL_NEWSLETTER':
					return Object.assign({}, state, {
						promotionalNewsletter: action.payload
					});

				case 'REGISTRATION_CLEAR':

					return Object.assign({}, state, {
						fullName: '',
						email: '',
						password: '',
						socmedId: undefined,
						businessId: undefined,
						mobilePhone: undefined,
						promotionalNewsletter: true,
						type: 'basic'
					});

				default:
					return state || {
						fullName: '',
						email: '',
						password: '',
						socmedId: undefined,
						businessId: undefined,
						mobilePhone: undefined,
						promotionalNewsletter: true,
						type: 'basic'
					};
			}
		}
		});

/***/ }),

/***/ 738:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var ComponentFactory = __webpack_require__(461),
	    React = __webpack_require__(1),
	    Formsy = __webpack_require__(673);

	module.exports = Formsy.Decorator()(ComponentFactory.create({
		displayName: 'Input',
		construct: function construct() {
			this.state = {
				blurred: false
			};
		},
		methods: {
			onChange: function onChange(e) {
				this.props.setValue(e.currentTarget.value);

				this.props.onChange && this.props.onChange(e, e.currentTarget.value);
			},
			onBlur: function onBlur() {
				if (!this.state.blurred) {
					this.setState({
						blurred: true
					});
				}

				var _value = this.props.getValue();

				if (_value) {
					_value = _value.trim();
				}

				this.props.setValue(_value);

				this.props.onBlur && this.props.onBlur();
			},
			getValue: function getValue() {
				return this.refs.input.value;
			}
		},
		render: function render() {

			var _additionalProps = {
				onClick: this.props.onClick,
				onFocus: this.props.onFocus,
				onKeyUp: this.props.onKeyUp,
				autoComplete: this.props.autoComplete,
				id: this.props.id,
				className: this.props.className,
				name: this.props.name,
				type: this.props.type || 'text',
				disabled: this.props.disabled,
				defaultValue: this.props.defaultValue,
				value: this.props.value,
				placeholder: this.props.placeholder,
				maxLength: this.props.maxLength,
				max: this.props.max,
				min: this.props.min
			};

			return React.createElement(
				'div',
				{ className: !this.props.isPristine() && (this.state.blurred || this.props.isFormSubmitted()) && (this.props.showError() || this.props.showRequired()) ? 'form-error' : '' },
				React.createElement('input', _extends({ ref: 'input' }, _additionalProps, { value: this.props.getValue() || '', onChange: this.onChange.bind(this), onBlur: this.onBlur.bind(this) })),
				React.createElement(
					'p',
					{ className: 'form-msg' },
					this.props.getErrorMessage()
				)
			);
		}
		}));

/***/ }),

/***/ 739:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	module.exports = function (location, callback) {
		if (true) __webpack_require__.e/* nsure */(4, function (require) {
			callback(null, __webpack_require__(740));
		});else callback(null, require('./component'));
		};

/***/ }),

/***/ 744:
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var init = function init(_callback) {
		try {
			if (window.google_auth2) {
				if (_callback) _callback();
				return;
			}

			throw 'error';
		} catch (error) {
			window.onGoogleLibraryLoad = function () {
				window.google_auth2 = google.accounts.oauth2.initTokenClient({
					// client_id: '906194913017-m05edkttb12v53qc1s0tmjg3jhuq6fp8.apps.googleusercontent.com',
					client_id: '868173029764-209c7p27dpmfhdmmbu4psru92u3gatig.apps.googleusercontent.com',
					scope: 'https://www.googleapis.com/auth/userinfo.email',
					callback: function callback(tokenResponse) {
						if (_callback) _callback(tokenResponse);
					}
				});
			};

			var installGoogleSdkScript = function installGoogleSdkScript(d, s, id) {
				if (d.getElementById(id)) return;

				var fjs = d.getElementsByTagName(s)[0];
				var js = d.createElement(s);
				js.id = id;
				js.src = 'https://accounts.google.com/gsi/client';
				fjs.parentNode.insertBefore(js, fjs);
			};

			installGoogleSdkScript(document, 'script', 'google-jssdk');
		}
	};

	exports.default = init;

/***/ })

});
